import React, { useState } from "react";
import ListSearchComponent from "../../MainContent/Dashboard/Filters/ListSearchComponent/ListSearchComponent";

import Popup from "semantic-ui-react/dist/es/modules/Popup";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";

import { ReactComponent as ArrowIcon } from "../../../assets/svg/up-arrow.svg";
import { ReactComponent as ExpandIcon } from "../../../assets/svg/add.svg";
import { ReactComponent as CollapseIcon } from "../../../assets/svg/minus.svg";
import { ReactComponent as SearchIcon } from "../../../assets/svg/search.svg";
import { ReactComponent as ResetIcon } from "../../../assets/svg/refresh.svg";

const UsersFilters = (props) => {
    const { userLists, filterRefineFilter, updateRefineFilter } = props;

    const [showSearch, setShowSearch] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [expand, setExpand] = useState(false);
    const [showAllselected, setShowAllselected] = useState(false);
    const [sortingBy, setSortingBy] = useState("name");
    const [sortingDirection, setSortingDirection] = useState("asc");

    const sortingChange = (type) => {
        if (sortingBy === type) {
            if (sortingDirection === "asc") {
                setSortingDirection("dec");
            } else {
                setSortingBy(null);
                setSortingDirection(null);
            }
        } else {
            setSortingBy(type);
            setSortingDirection("asc");
        }
    };

    const unselectFilter = (id) => {
        let usersSelected = [];
        if (id !== "selectAll") {
            if (filterRefineFilter.users[0] === "selectAll") {
                userLists.forEach((p) => {
                    if (p.id !== id) usersSelected.push(p.id);
                });
            } else usersSelected = filterRefineFilter.users.filter((p) => p !== id);
        }
        updateRefineFilter({ ...filterRefineFilter, users: usersSelected });
    };

    const selectFilter = (id) => {
        let usersSelected = filterRefineFilter.users;
        if (id === "selectAll") {
            usersSelected = ["selectAll"];
        } else {
            if (usersSelected[0] === "selectAll") usersSelected[0];
            usersSelected.push(id);
            if (usersSelected.length === userLists.length) usersSelected = ["selectAll"];
        }

        updateRefineFilter({ ...filterRefineFilter, users: usersSelected });
    };

    const updateSearchValue = (searchText) => {
        if (searchText) {
            setSearchText(searchText);
        } else {
            setSearchText("");
            setShowSearch(false);
        }
    };

    const filterDisplay = () => {
        let searchtext = searchText.trim();
        let users = userLists.slice(0);

        if (searchtext !== "") {
            users = users.filter((p) => p.name.toLowerCase().indexOf(searchtext.toLowerCase()) > -1);
            if (users.length === 0)
                return (
                    <div className="filter-messages">
                        <p className="empty-message">Sorry. No results found</p>
                    </div>
                );
        }

        if (sortingBy) {
            let order = sortingDirection === "asc" ? 1 : -1;
            if (sortingBy === "name") {
                users.sort((a, b) => {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) {
                        return -1 * order;
                    }
                    if (a.name.toLowerCase() > b.name.toLowerCase()) {
                        return 1 * order;
                    }
                    return 0;
                });
            }
        }

        let usersSelected = filterRefineFilter.users;

        if (!usersSelected) return;
        let flag = !showSearch && !expand && !showAllselected;

        let usersSelectedDisplay = [];
        let allUsersSelectedDisplay = [];
        let selectAllChecked = false;
        if (usersSelected[0] === "selectAll") {
            allUsersSelectedDisplay = users;
            selectAllChecked = true;
        } else
            users.forEach((p) => {
                if (showSearch) allUsersSelectedDisplay.push(p);
                else if (usersSelected.includes(p.id)) allUsersSelectedDisplay.push(p);
            });

        if (!showAllselected && !showSearch) usersSelectedDisplay = allUsersSelectedDisplay.slice(0, 5);
        else usersSelectedDisplay = allUsersSelectedDisplay;

        return (
            <>
                <div className="filter-list-items">
                    {(expand || showSearch) && (
                        <div className="filter-list-item">
                            <Checkbox
                                checked={selectAllChecked}
                                label="Select All"
                                onClick={() => (selectAllChecked ? unselectFilter("selectAll") : selectFilter("selectAll"))}
                            />
                        </div>
                    )}
                    {expand
                        ? users.map((p) => {
                              let checked = selectAllChecked || usersSelected.includes(p.id);
                              return (
                                  <div className="filter-list-item" key={p.id + "expanded"}>
                                      <Checkbox checked={checked} label={p.name} onClick={() => (checked ? unselectFilter(p.id) : selectFilter(p.id))} />
                                  </div>
                              );
                          })
                        : usersSelectedDisplay.map((p) => {
                              let checked = showSearch ? selectAllChecked || usersSelected.includes(p.id) : true;
                              return (
                                  <div className="filter-list-item" key={p.id + "collapsed"}>
                                      <Checkbox checked={checked} label={p.name} onClick={() => (checked ? unselectFilter(p.id) : selectFilter(p.id))} />
                                  </div>
                              );
                          })}
                </div>
                <div className="filter-messages">
                    {flag && !showAllselected && allUsersSelectedDisplay.length > 5 && (
                        <span onClick={() => setShowAllselected(true)} className="show-more">
                            + {allUsersSelectedDisplay.length - 5} more
                        </span>
                    )}
                    {!expand && usersSelectedDisplay.length === 0 && (
                        <p className="empty-message">
                            Click on <span>{`"+"`}</span> to expand and select a user
                        </p>
                    )}
                </div>
            </>
        );
    };

    return (
        <div className="filter-type">
            {!showSearch ? (
                <div className="filter-type-header">
                    <div className="filter-type-header-left">
                        <span className="filter-type-name">Users</span>
                        <span
                            onClick={() => sortingChange("name")}
                            title="Sort"
                            className={`sorting-arrow ${
                                sortingBy === "name" ? (sortingDirection === "dec" ? "arrow-persistent arrow-downwards" : "arrow-persistent") : ""
                            } `}>
                            <ArrowIcon />
                        </span>
                    </div>
                    <div className="filter-type-header-right">
                        <Popup
                            className="skiptranslate"
                            trigger={<ResetIcon onClick={() => unselectFilter("selectAll")} />}
                            content="Clear all"
                            inverted
                            position="bottom center"
                            size="mini"
                            style={{ zIndex: "9999999" }}
                        />
                        <Popup
                            className="skiptranslate"
                            trigger={<SearchIcon className="search" onClick={() => setShowSearch(true)} />}
                            content="Search in Users"
                            inverted
                            position="bottom center"
                            size="mini"
                            style={{ zIndex: "9999999" }}
                        />
                        <span className="filter-items-expand-button">
                            {expand ? (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        <CollapseIcon
                                            onClick={() => {
                                                setExpand(false);
                                                setShowAllselected(false);
                                            }}
                                        />
                                    }
                                    content="Collapse"
                                    inverted
                                    position="bottom center"
                                    size="mini"
                                    style={{ zIndex: "9999999" }}
                                />
                            ) : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        <ExpandIcon
                                            onClick={() => {
                                                setExpand(true);
                                                setShowAllselected(false);
                                            }}
                                        />
                                    }
                                    content="Expand"
                                    inverted
                                    position="bottom center"
                                    size="mini"
                                    style={{ zIndex: "9999999" }}
                                />
                            )}
                        </span>
                    </div>
                </div>
            ) : (
                <ListSearchComponent value={searchText} placeholder="Search for Users" focusInput showClear={true} updateValue={updateSearchValue} />
            )}
            {filterDisplay()}
        </div>
    );
};

export default UsersFilters;
